// Footer. Organizer name at display size, the "open admin" button for admins.
import { Icon } from '../lib/icons';
import { COL, MONO } from './primitives';

export function Footer({
  organizerName,
  organizerPhone,
  organizerPhoneHref,
  organizerEmail,
  signedIn,
  isAdmin,
  onOpenAdmin,
}: {
  organizerName: string;
  organizerPhone: string;
  organizerPhoneHref: string;
  organizerEmail: string;
  signedIn: boolean;
  isAdmin: boolean;
  onOpenAdmin: () => void;
}) {
  return (
    <footer style={{ marginTop: 64, borderTop: '2px solid var(--cyan)', background: 'var(--deeper)' }}>
      <div style={{ ...COL, padding: '36px 20px 44px' }}>
        {signedIn ? (
          <>
            <div
              style={{ fontSize: 'clamp(30px,8vw,40px)', fontWeight: 900, letterSpacing: '-0.04em', lineHeight: 1 }}
            >
              {organizerName}
            </div>
            <div
              style={{
                fontFamily: MONO,
                fontSize: 13,
                letterSpacing: '0.14em',
                textTransform: 'uppercase',
                color: 'var(--cyan)',
                marginTop: 8,
              }}
            >
              running this, badly
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 22 }}>
              <a
                href={organizerPhoneHref}
                style={{ display: 'flex', alignItems: 'center', gap: 14, minHeight: 56, fontSize: 21, fontWeight: 600 }}
              >
                <Icon name="phone" size={26} style={{ flex: 'none' }} />
                {organizerPhone}
              </a>
              <a
                href={`mailto:${organizerEmail}`}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 14,
                  minHeight: 56,
                  fontSize: 21,
                  fontWeight: 600,
                  wordBreak: 'break-all',
                }}
              >
                <Icon name="mail" size={26} style={{ flex: 'none' }} />
                {organizerEmail}
              </a>
            </div>
            <p style={{ fontSize: 17, lineHeight: 1.6, color: 'var(--muted)', margin: '20px 0 0', textWrap: 'pretty' }}>
              text is faster. or call and tell me your dates — i'll enter them myself.
            </p>
          </>
        ) : (
          <div style={{ fontSize: 19, lineHeight: 1.5, color: 'var(--body-2)', textWrap: 'pretty' }}>
            a mcmahon reunion, summer 2027.{' '}
            <a className="wh-link" href="#respond">
              sign in
            </a>{' '}
            to see who's coming and how to reach me.
          </div>
        )}
        <div style={{ fontFamily: MONO, fontSize: 12, color: 'var(--dim)', marginTop: 26 }}>
          waterhazard27.com · not indexed, not public, not on facebook
        </div>
        {isAdmin && (
          <button
            type="button"
            className="wh-ghost on-card"
            onClick={onOpenAdmin}
            style={{
              minHeight: 52,
              padding: '0 18px',
              marginTop: 20,
              fontFamily: MONO,
              fontSize: 14,
              fontWeight: 400,
              display: 'inline-flex',
              borderColor: 'rgba(127,227,232,0.4)',
            }}
          >
            open admin
          </button>
        )}
      </div>
    </footer>
  );
}
